import { css } from '@emotion/react'
import { Fade, Tooltip } from '@mui/material'
import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import { getThemeSpacing } from '../../../styles/appTheme'

export const EMOTICON_HEIGHT = 64
export const EMOTICON_WIDTH = EMOTICON_HEIGHT

const buttonContainerStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
})

const buttonStyles = css({
    border: 0,
    padding: 0,
    height: EMOTICON_HEIGHT,
    width: EMOTICON_WIDTH,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: '4px !important',
    '&:hover': {
        borderRadius: '4px !important',
    },
})

const imageContainerStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    minHeight: 0,
    marginTop: getThemeSpacing(1),
})

const shortcutTextStyles = css({
    fontSize: 8,
    lineHeight: 1.1,
    color: 'inherit',
    opacity: 0.7,
    textAlign: 'center',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginBottom: getThemeSpacing(0.5),
})

interface ItemData {
    id: number
    key: string
}

interface IEmoticon {
    itemData?: ItemData
    darkMode?: boolean
    onClickEmoticon(key: string): void
}

const Emoticon = memo((props: IEmoticon) => {
    const { itemData, darkMode, onClickEmoticon } = props

    if (!itemData) return null

    const { key, id } = itemData

    const handleOnClick = () => onClickEmoticon(key)

    const path = darkMode ? 'chat_images/e/dark' : 'chat_images/e'
    const imgSrc = `https://img.mfcimg.com/${path}/${id}.gif`

    return (
        <Tooltip
            disableFocusListener
            disableTouchListener
            enterDelay={250}
            placement="top"
            title={key}
            slots={{
                transition: Fade,
            }}
        >
            <div css={buttonContainerStyles} key={key}>
                <IconButton
                    css={[buttonStyles]}
                    onClick={handleOnClick}
                    title={key}
                >
                    <div css={imageContainerStyles}>
                        <img src={imgSrc} alt={key} />
                    </div>
                    <div css={shortcutTextStyles}>{key}</div>
                </IconButton>
            </div>
        </Tooltip>
    )
})

export default Emoticon
